define.alias("ember-composable-helpers/helpers/drop", "settings/helpers/drop");